/* eslint-disable no-param-reassign */
import type { Data } from '../../specProcessor';
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as ContrastDoubleBarLayerSpec } from '../../../../layer/preset/bar/contrastDoubleBar';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface ContrastDoubleBarLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type ContrastDoubleBarLayerType = StandardChartLayerSpec &
  ContrastDoubleBarLayerSpec &
  ContrastDoubleBarLayerTypeWithFields;

// 创建对比柱中柱状图数据类型验证器
const validateContrastDoubleBarDataTypes = createDataTypeValidator('contrastDoubleBar', [
  { field: 'x', type: 'string' },
  { field: 'y', type: 'number' },
  { field: 'z', type: 'string' }
]);

// 创建对比柱中柱状图编码验证器
const validateContrastDoubleBarEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'z' }
]);

// 额外的检查函数
const additionalContrastDoubleBarChecks = (layer: ContrastDoubleBarLayerType, data: Data) => {
  const { encoding, type } = layer;
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];

  if (!values.length || !encoding.z) {
    return;
  }

  // 检查Z轴的分类值恰好有两个
  const zValues = new Set(values.map(item => item[encoding.z]));
  if (zValues.size !== 2) {
    utils.logger.warn(
      'warning',
      `The "z" field of the "${type}" layer must have exactly 2 unique values, but got ${zValues.size}`
    );
    layer.__isEncodingValid = false;
  }
};

// 创建并导出对比柱中柱状图处理器
export const contrastDoubleBar = createLayerProcessor<ContrastDoubleBarLayerType>(
  'contrastDoubleBar',
  validateContrastDoubleBarEncoding,
  validateContrastDoubleBarDataTypes,
  additionalContrastDoubleBarChecks
);
